// @mui
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
//
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';

export default function NotFoundPage() {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ minHeight: '100vh' }}>
      <Typography variant="h3">Page not found</Typography>
      <Button component={RouterLink} href={paths.filings.root} variant="contained" color="secondary">
        Go to my filings
      </Button>
    </Stack>
  );
}
